'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var handleTriggerClick = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref3) {
    var els = _ref3.els,
        state = _ref3.state,
        initialState = _ref3.initialState;

    var shouldUpdateCurrentAmountViewed, parsedQueryString, parsedQuerystring, _ref4, data, fragment, div, newElements, perspectiveElements;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            shouldUpdateCurrentAmountViewed = els.text != null;
            parsedQueryString = _queryString2.default.parse(window.location.search);

            state.loading = true;
            initialState.currentPage += 1;

            parsedQuerystring = (0, _assign2.default)({}, parsedQueryString);

            parsedQuerystring.page = initialState.currentPage;
            _context.next = 8;
            return _axios2.default.get(initialState.url + '?' + _queryString2.default.stringify(parsedQuerystring));

          case 8:
            _ref4 = _context.sent;
            data = _ref4.data;

            state.loading = false;
            fragment = document.createDocumentFragment();
            div = (0, _functional.createElement)('div');

            div.innerHTML = data;
            newElements = (0, _functional.getElements)(initialState.itemClassName, { context: div });

            newElements.forEach(function (item) {
              fragment.appendChild(item);
            });

            els.target.appendChild(fragment);

            if (shouldUpdateCurrentAmountViewed) {
              setCurrentAmountViewed({ els: els, initialState: initialState });
            }

            perspectiveElements = (0, _functional.getElements)('[data-module="perspective-tilt"]', { context: div });

            perspectiveElements.forEach(function (el) {
              perspectiveTiltModule.init({
                el: el,
                context: (0, _helpers.createContext)(el)
              });
            });

          // window.Currency.convertAll(
          //   window.Currency.shopCurrency,
          //   window.Currency.currentCurrency
          // )

          case 20:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function handleTriggerClick(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.init = init;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _viewprt = require('viewprt');

var _functional = require('../utils/functional');

var _listeners = require('../utils/listeners');

var _reactiveState = require('../utils/reactive-state');

var _helpers = require('./_helpers');

var _perspectiveTilt = require('./perspective-tilt');

var perspectiveTiltModule = _interopRequireWildcard(_perspectiveTilt);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var state = new _reactiveState.ReactiveState({
    loading: false
  });
  var listeners = new _listeners.Listeners();

  var initialState = {
    itemClassName: el.dataset.itemClassName,
    itemClassNameToExclude: el.dataset.itemClassNameToExclude,
    perPage: parseInt(el.dataset.perPage, 10),
    currentPage: parseInt(el.dataset.currentPage, 10),
    textTemplate: el.dataset.textTemplate,
    totalItems: parseInt(el.dataset.totalItems, 10),
    url: el.dataset.url
  };

  var els = {
    el: el,
    target: context.getElement('.' + context.className + '_Target'),
    pagination: context.getElement('.' + context.className + '_Pagination'),
    text: context.getElement('.' + context.className + '_Text'),
    trigger: context.getElement('.' + context.className + '_Trigger')
  };

  if (els.pagination == null) return;

  function handleClick() {
    return handleTriggerClick({ els: els, state: state, initialState: initialState });
  }

  listeners.add(els.trigger, 'click', handleClick);

  state.subscribe('loading', function (val) {
    els.el.classList.toggle(context.className + '-loading', val);
  });

  (0, _viewprt.ElementObserver)(els.trigger, {
    onEnter: function onEnter() {
      var event = new Event('click');
      els.trigger.dispatchEvent(event);
    }
  });
}

function setCurrentAmountViewed(_ref5) {
  var els = _ref5.els,
      initialState = _ref5.initialState;

  var hasExcludeClasses = initialState.itemClassNameToExclude !== undefined;
  var classesToFind = hasExcludeClasses ? initialState.itemClassName + ':not(' + initialState.itemClassNameToExclude + ')' : '' + initialState.itemClassName;

  var currentTotal = (0, _functional.getElements)(classesToFind).length;
  var totalCount = initialState.totalItems;
  els.text.innerText = initialState.textTemplate.replace('{{ pagination_amount }}', currentTotal).replace('{{ total_count }}', totalCount);

  if (currentTotal === initialState.totalItems) {
    els.pagination.remove();
  }
}